module.exports = __webpack_public_path__ + "img/hospital-user.5c98e678.png";